var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.867 24.5-7.35-7.35a7.11 7.11 0 0 1-4.433 1.517q-3.18 0-5.382-2.202T3.5 11.083t2.202-5.38T11.083 3.5q3.18 0 5.382 2.202t2.202 5.381a7.1 7.1 0 0 1-1.517 4.434l7.35 7.35zm-11.784-8.167q2.188 0 3.72-1.53 1.53-1.532 1.53-3.72 0-2.187-1.53-3.718-1.532-1.532-3.72-1.532-2.187 0-3.718 1.532-1.532 1.53-1.532 3.718t1.532 3.72 3.718 1.53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c80ba6c20947855daef8dc09ca690968.svg";
export { ForwardRef as ReactComponent };